export type WorkspaceType = 'organization' | 'personal_organizer';

export type ActiveWorkspace = {
  type: WorkspaceType;
  id: string;
  label: string;
  organizationId?: string | null;
};

const STORAGE_KEY = 'enthioshub.active_workspace';

export function readActiveWorkspace(): ActiveWorkspace | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ActiveWorkspace;
    if (!parsed?.type || !parsed?.id) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeActiveWorkspace(workspace: ActiveWorkspace): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(workspace));
}

export function clearActiveWorkspace(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(STORAGE_KEY);
}

export const WORKSPACE_ORIGIN_KEY = 'enthioshub.event_origin';

export type EventOrigin = {
  href: string;
  label: string;
};

export function readEventOrigin(): EventOrigin | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(WORKSPACE_ORIGIN_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as EventOrigin;
  } catch {
    return null;
  }
}

export function writeEventOrigin(origin: EventOrigin): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(WORKSPACE_ORIGIN_KEY, JSON.stringify(origin));
}
